import React, { useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import BeforeQuestionnair from '../components/BeforeQuestionnair';
import AfterQuestionnair from '../components/AfterQuestionnair';
import MainQuestionnair from '../components/MainQuestionnair';

function UndergroundMall() {
    const [questionnairestep, setQuestionnairestep] = useState(1);
    const formRef = useRef(null);
    
    // --- クエリパラメータ取得（HashRouter対応）---
    const getGroupParam = () => {
        const hash = window.location.hash;
        const queryIndex = hash.indexOf('?');
        if (queryIndex !== -1) {
            const queryString = hash.substring(queryIndex + 1);
            const params = new URLSearchParams(queryString);
            if (params.has('group')) return params.get('group');
        }
        return 'A';
    };
    const group = getGroupParam();
    
    const moveOnToTheNextStep = () => {
        if (questionnairestep === 3) return;
        setQuestionnairestep(questionnairestep + 1);
    }
    
    return (
        <>
            <Helmet>
                <title>避難行動に関するアンケート</title>
                <meta name="description" content="火災時の避難行動に関するアンケートです。" />
            </Helmet>
            
            <form
                ref={formRef}
                className="questionnaire"
                method="post"
                action={`${process.env.PUBLIC_URL}/receive.php`}
                onSubmit={moveOnToTheNextStep}
            >
                <div
                    className={`questionnaire-form-container ${questionnairestep === 1 && "is-active"}`}
                    inert={questionnairestep !== 1 ? '' : undefined}
                >
                    <BeforeQuestionnair moveOnToTheNextStep={moveOnToTheNextStep} />
                </div>
                <div
                    className={`main-questionnaire-container ${questionnairestep === 2 ? ' is-active' : ''}`}
                    inert={questionnairestep !== 2 ? '' : undefined}
                >
                    <MainQuestionnair
                        moveOnToTheNextStep={moveOnToTheNextStep}
                        isActive={questionnairestep === 2}
                        group={group}
                    />
                </div>
                <div
                    className={`questionnaire-form-container ${questionnairestep === 3 && "is-active"}`}
                    inert={questionnairestep !== 3 ? '' : undefined}
                >
                    <AfterQuestionnair />
                </div>
            </form>
        </>
    );
}
    
export default UndergroundMall;